import * as React from "react";
import { Input, Form, Col, Divider, Row, Checkbox } from "antd";
import { FormInstance } from "antd/lib/form";
import { CourtCaseType } from "../../common/Constants";
import { ICourtCase } from "../../model/CourtCase";
import FormItem from "antd/lib/form/FormItem";
import SelectInput from "../../../core/ui/components/SelectInput";
import { ICourtCaseConnectionType } from "../../model/CourtCaseConnectionType";
import CaseLawDocumentCourtCaseDescription from "./CaseLawDocumentCourtCaseDescription";
import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import CourtCaseNumberInput from "../../../core/ui/components/CourtCaseNumberInput";
import { TCourtPhaseSelectionModel } from "./CourtCaseEntryForm";
import { ICasePhase } from "../../model/CasePhase";
import { ICaseDecision } from "../../../caseDecisions/model/CaseDecision";
const FormFields = {
  COURT_CASE_NUMBER: "courtCaseNumber",
  COURT_CASE_TYPE: "caseType",
  CONNECTION_TYPE: "connectionTypeId"
};
export interface State {
  selectedCourtPhases?: TCourtPhaseSelectionModel[];
  selectedConnectedDecisions?: { [courtCaseNumber: string]: ICaseDecision };
}
export interface Props {
  translate: any;
  form: FormInstance;
  rowData?: ICourtCase;
  connectionTypes: ICourtCaseConnectionType[];
  selectedCaseDecision?: ICaseDecision;
  updateCourtCaseSelection;
  courtCaseSelectionResult;
  findCourtCase: any;
  decisionTypes: IGenericCodebookItem[];
  onSelectCaseDecision(courtCase: ICourtCase, value: ICaseDecision);
}

export default class CourtCaseForm extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { selectedCourtPhases: [] };
    this.onSelectCasePhaseDecision = this.onSelectCasePhaseDecision.bind(this);
  }

  private onChangeConnectionType(id: number, courtCaseNumber) {
    let selectedCourtPhases = this.state.selectedCourtPhases;
    if (selectedCourtPhases) {
      let index = selectedCourtPhases.findIndex(
        (item) => item?.phase?.courtCaseNumber === courtCaseNumber
      );
      if (index !== -1) {
        selectedCourtPhases[index].connectionTypeId = id;
        this.setState({ selectedCourtPhases });
      }
    }
  }

  private onSelectCasePhaseDecision(phase: ICasePhase, value: ICaseDecision) {
    this.setState((prevState, props) => {
      let selectedPhases = prevState.selectedCourtPhases;
      let result = selectedPhases?.find(
        (item) => item.phase.courtCaseNumber === phase.courtCaseNumber
      );
      if (result) {
        result.caseDecision = value;
        let selectedConnectedDecision = this.state.selectedConnectedDecisions;
        if (selectedConnectedDecision) {
          selectedConnectedDecision[phase.courtCaseNumber] = value;
        }
        return {
          selectedCourtPhases: selectedPhases,
          selectedConnectedDecisions: selectedConnectedDecision
        };
      }
      return null;
    });
  }

  render() {
    const {
      translate,
      rowData,
      form,
      connectionTypes,
      courtCaseSelectionResult,
      findCourtCase,
      decisionTypes,
      onSelectCaseDecision,
      selectedCaseDecision
    } = this.props;

    function addCourtCaseNumber(caseNumber: string) {
      form.setFieldsValue({ courtCaseNumber: caseNumber });
      findCourtCase(caseNumber);
    }
    return (
      <Form layout={"vertical"} form={form}>
        <Form.Item
          initialValue={rowData?.courtCaseNumber}
          rules={[
            {
              required: true,
              message: translate(
                "editors.case_law_documents.required_messages",
                {
                  field: translate(
                    "editors.case_law_documents.case_law_document_type"
                  )
                }
              )
            }
          ]}
          label={translate("editors.case_law_documents.connected_court_case")}
          name={FormFields.COURT_CASE_NUMBER}
        >
          <CourtCaseNumberInput onSearch={addCourtCaseNumber} searchOnBlur />
        </Form.Item>

        <Form.Item
          label={"TIP"}
          name={FormFields.COURT_CASE_TYPE}
          style={{ display: "none" }}
          initialValue={CourtCaseType.CONNECTED}
        >
          <Input style={{ width: "100%" }} />
        </Form.Item>
        {courtCaseSelectionResult && (
          <Col style={{ marginTop: 20 }}>
            <CaseLawDocumentCourtCaseDescription
              courtCase={courtCaseSelectionResult}
              selectedDecision={selectedCaseDecision}
              onSelectDecision={(value) => {
                onSelectCaseDecision(courtCaseSelectionResult, value);
              }}
              translate={translate}
              showDecisions
              decisionTypes={decisionTypes}
            />
          </Col>
        )}
        <FormItem
          label={translate(
            "editors.case_law_documents.connected_cases.connection_type"
          )}
          name={FormFields.CONNECTION_TYPE}
          initialValue={rowData?.connectionTypeId}
        >
          <SelectInput
            placeholder={translate(
              "editors.court_cases.entry_form.select_connection_type"
            )}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
            selectOptionKey={"id"}
            selectOptionValue={"name"}
            selectOptions={connectionTypes}
          />
        </FormItem>
        {courtCaseSelectionResult?.phases?.length ? (
          <>
            <Divider orientation="left">
              {translate("editors.court_cases.entry_form.connected_cases")}
            </Divider>
            <div>
              {courtCaseSelectionResult?.phases?.map((phase, index) => {
                if (phase.courtCase && phase.courtCase.decisions.length > 0)
                  return (
                    <div
                      key={`phase-item-${index}`}
                      style={{ marginLeft: 24, marginBottom: 12 }}
                    >
                      <Row>
                        <Col span={16}>
                          <Checkbox
                            style={{ marginTop: 4 }}
                            defaultChecked={false}
                            onChange={(e) => {
                              if (e.target.checked) {
                                let selectedPhases =
                                  this.state.selectedCourtPhases || [];
                                let selectedConnectedDecision =
                                  this.state.selectedConnectedDecisions || {};
                                selectedConnectedDecision[
                                  phase.courtCaseNumber
                                ] = phase?.courtCase.decisions?.[0];

                                this.setState({
                                  selectedCourtPhases: [
                                    ...selectedPhases,
                                    {
                                      phase,
                                      caseDecision:
                                        phase.courtCase.decisions?.[0],
                                      connectionTypeId: connectionTypes?.[0].id
                                    }
                                  ],
                                  selectedConnectedDecisions:
                                    selectedConnectedDecision
                                });
                              } else {
                                this.setState({
                                  selectedCourtPhases:
                                    this.state.selectedCourtPhases?.filter(
                                      (item) =>
                                        item.phase.courtCaseNumber !==
                                        phase.courtCaseNumber
                                    )
                                });
                              }
                            }}
                          >
                            {phase.courtCaseNumber}
                          </Checkbox>
                        </Col>

                        <Col
                          span={8}
                          style={
                            this.state.selectedCourtPhases?.findIndex(
                              (item) =>
                                item.phase?.courtCaseNumber ===
                                phase?.courtCaseNumber
                            ) === -1
                              ? { display: "none" }
                              : { textAlign: "right" }
                          }
                        >
                          <SelectInput
                            placeholder={translate(
                              "editors.court_cases.entry_form.select_connection_type"
                            )}
                            allowClear
                            showSearch={true}
                            notFoundContent={translate("search.no_data")}
                            selectOptionKey={"id"}
                            selectOptionValue={"name"}
                            selectOptions={connectionTypes}
                            defaultActiveFirstOption={true}
                            defaultValue={connectionTypes?.[0].id}
                            onChange={(value) => {
                              this.onChangeConnectionType(
                                value,
                                phase.courtCaseNumber
                              );
                            }}
                          />
                        </Col>
                      </Row>

                      {this.state.selectedCourtPhases?.some(
                        (item) =>
                          item.phase.courtCaseNumber ===
                            phase.courtCaseNumber &&
                          item?.phase?.courtCase?.decisions.length > 0
                      ) ? (
                        <div style={{ marginLeft: 25, marginTop: 12 }}>
                          <CaseLawDocumentCourtCaseDescription
                            translate={translate}
                            courtCase={phase.courtCase}
                            decisionTypes={decisionTypes}
                            showDecisions
                            compact
                            selectedDecision={
                              this.state.selectedConnectedDecisions?.[
                                phase.courtCaseNumber
                              ]
                            }
                            onSelectDecision={(value) => {
                              this.onSelectCasePhaseDecision(phase, value);
                            }}
                          />
                        </div>
                      ) : null}
                    </div>
                  );
              })}
            </div>
          </>
        ) : null}
      </Form>
    );
  }
}
